import { render } from "./Branches.vue?vue&type=template&id=6aac5ae6&scoped=true"
import script from "./Branches.vue?vue&type=script&lang=js"
export * from "./Branches.vue?vue&type=script&lang=js"

import "./Branches.vue?vue&type=style&index=0&id=6aac5ae6&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aac5ae6"]])

export default __exports__